// Future visits default to the waiting room; the day is decided on the site's calendar.

import { getCurrentTimeInTimezone } from 'common/services/dateService'
import type { IPatientRoom } from 'features/Home/interfaces/IInfoPatient'

// A YYYY-MM-DD day after today in the site's zone; no zone means we cannot tell.
export const isFutureSiteDay = (day: string | undefined, timeZone: string | undefined): boolean => {
  if (!day || !timeZone) return false
  return day > getCurrentTimeInTimezone(timeZone).format('YYYY-MM-DD')
}

export const roomForDay = (
  room: string,
  day: string | undefined,
  timeZone: string | undefined,
  rooms: IPatientRoom[],
): string => {
  if (!isFutureSiteDay(day, timeZone)) return room
  const waitingRoom = rooms.find((item) => item.is_waiting_room)
  return waitingRoom ? String(waitingRoom.value) : room
}
